export class Wrapper<T> {
    value: T;
}
